import { render, staticRenderFns } from "./NsrRbuItemModuleGroup.vue?vue&type=template&id=3f8ddbfe"
import script from "./NsrRbuItemModuleGroup.vue?vue&type=script&lang=js"
export * from "./NsrRbuItemModuleGroup.vue?vue&type=script&lang=js"
import style0 from "./NsrRbuItemModuleGroup.vue?vue&type=style&index=0&id=3f8ddbfe&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports